import "AWS-UI-Components-React/index.css";
import HeaderBar from './components/HeaderBar';
import React from 'react';
import ReactDOM from 'react-dom';
import {Form, Button, FormSection, ColumnLayout} from 'AWS-UI-Components-React';
import UploadFile from "./components/uploadFile";
import logo from './logo.svg';

function App() {
  return (
    <div className="awsui">
        <UploadFile />

    </div>
  );
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js